import moment from 'moment';//时间
import { $api } from '@/config/api';
import OSS from 'ali-oss';
import { showHtml,delHtml } from './showHtml';


import {
	getSignatureUrl
} from './oss-signature.js';

// 处理浮点数的问题
export const  priceToFen = (price) => {
    if (price === null || price === undefined || price === '') return 0;
  return Math.round(Number(price + 'e2'));
}

// 处理为oss的链接
export const ossContent = (fileKey) => {
  	// 1. 从后端获取STS临时凭证
		let stsData = JSON.parse(localStorage.getItem('oss'))

    if (fileKey.indexOf('OSSAccessKeyId') == -1 && (fileKey.indexOf('oss-cn-beijing.aliyuncs.com') != -1 
    ||fileKey.indexOf('file.marathonbm.com') != -1
     || fileKey.indexOf("marathon-image.hpaopao.com") != -1 
        || fileKey.indexOf("static.hpaopao.com") != -1 
        || fileKey.indexOf("marathon-web.hpaopao.com") != -1 
      || fileKey.indexOf("paopao-image.hpaopao.com") != -1 
      || fileKey.indexOf("psq-img.hpaopao.com") != -1)) {
      let a = ''
      let bucket = 'marathon-bm-file'
      let domain = 'https://file.marathonbm.com'
     	if (fileKey.indexOf('file.marathonbm.com') != -1) {
			a = fileKey.split('https://file.marathonbm.com/')
			bucket = 'marathon-bm-file'
			domain = 'https://file.marathonbm.com'
		} else if (fileKey.indexOf("marathon-image.hpaopao.com") != -1) {
			// a = fileKey.split('http://marathon-image.hpaopao.com/')||fileKey.split('https://marathon-image.hpaopao.com/')
      if(fileKey.indexOf("http://marathon-image.hpaopao.com") != -1){
				a = fileKey.split('http://marathon-image.hpaopao.com/')
			}else{
				a = fileKey.split('https://marathon-image.hpaopao.com/')
			}
			bucket = 'marathon-image'
			domain = 'https://marathon-image.hpaopao.com'
		} else if (fileKey.indexOf("static.hpaopao.com") != -1) {
			a = fileKey.split('https://static.hpaopao.com/')
			bucket = 'marathon-webs'
			domain = 'https://static.hpaopao.com'
		} else if (fileKey.indexOf("marathon-web.hpaopao.com") != -1) {
			a = fileKey.split('https://marathon-web.hpaopao.com/')
			bucket = 'marathon-webs'
			domain = 'https://marathon-web.hpaopao.com'
		} else if (fileKey.indexOf("paopao-image.hpaopao.com") != -1) {
			a = fileKey.split('https://paopao-image.hpaopao.com/')
			bucket = 'paopao-image'
			domain = 'https://paopao-image.hpaopao.com'
		} else if (fileKey.indexOf("psq-img.hpaopao.com") != -1) {
			a = fileKey.split('https://psq-img.hpaopao.com/')
			bucket = 'psq-image'
			domain = 'https://psq-img.hpaopao.com'
		}else{
			a = fileKey.split('oss-cn-beijing.aliyuncs.com/')
      bucket = fileKey.split('//')[1].split('.oss-cn-beijing.aliyuncs.com/')[0]
      console.log('bucket',bucket)
    }



      if (stsData) {
       	const url = getSignatureUrl({
				accessKeyId: stsData.accessKeyId,
				accessKeySecret: stsData.accessKeySecret,
				stsToken: stsData.securityToken,
				bucket: bucket,
				region: 'oss-cn-beijing', // 你的Bucket所在区域
				endpoint: domain,
				objectKey: decodeURIComponent(a[1]),
				exp: 600,
				cname:false
			});

			let array = ['982285707324166266', '982285927139250176', '982285927139250181', '982285927139250186',
				'982285927139250178'
			]
			var randomIndex = Math.floor(Math.random() * array.length);
			var srcNumber = array[randomIndex];
			return `${url}&requestId=${srcNumber}`
      // } else {
      //   return fileKey;
      // }
    } else {
      return fileKey;
    }
  }
}

/* 中国标准时间 转 正常时间 */
export const FORMATTIME = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : ''
}

export const handleHoverImg = () => {
  // 获取页面上hoverImg下所有的img
  var imageSrc = document.querySelectorAll('.hoverImg img')
  if (imageSrc && imageSrc.length) {
    imageSrc.forEach(item => {
      item.src = handleSrcContent(decodeURIComponent(item.src))
    })
  }
  console.log(imageSrc)
  return imageSrc
}


export const handleZoomImg = () => {
  var imageSrc = document.querySelector('.zoomImg')
  if (imageSrc && imageSrc.src) {
    imageSrc.src = handleSrcContent(imageSrc.src)
      console.log('----->',imageSrc.src)
  }

  return imageSrc
}




export const handleSetHtml = (value, flag) => {
  console.log('处理富文本数据---->', value, flag)
  if(!value){
    return ''
  } else{
      if(flag === 'edit'){
        return showHtml(value)
      }else{
        return delHtml(value)
      }
  }

  
}




// 加密为oss
export const handleSrcContent = (url) => {
  let urlArr = []
  let urls = []
  let typeofUrl = 'string'
  if (url) {
    if (typeof url === 'string') {
      typeofUrl = 'string'
      // 处理原始数据----->
      urlArr = url.split(',')
    } else {
      typeofUrl = 'array'
      urlArr = url
    }
    // 判断域名只要是这些 就需要处理位oss
    // item.indexOf('OSSAccessKeyId') == -1 
    urlArr.map(item => {
      if ((item.indexOf('oss-cn-beijing.aliyuncs.com') != -1 
      ||item.indexOf('file.marathonbm.com') != -1 
        || item.indexOf("marathon-image.hpaopao.com") != -1 
        || item.indexOf("static.hpaopao.com") != -1 
        || item.indexOf("marathon-web.hpaopao.com") != -1 
        || item.indexOf("paopao-image.hpaopao.com") != -1 
        || item.indexOf("psq-img.hpaopao.com") != -1)) {
        if (item.indexOf('?') !== -1) {
          // urls.push(`${item}&requestId=${srcNumber}`)
          let a = item.split('?')
          urls.push(ossContent(a[0]))

        }else{
          urls.push(ossContent(item))
        }
        
      } else {
        urls.push(item)
      }
    })
  }
  // console.log('返回的数据---->',urls)


  if (typeofUrl == 'string') {
    return urls.toString()
  } else {
    return urls
  }
}





/* 中国标准时间/毫秒值 转 正常时间 带时分秒 */
export const TIMEFORMATmin = (msec) => {
  let datetime = new Date(msec);
  // console.log(' 自定义时间转换 ', datetime)
  let year = datetime.getFullYear();
  let month = datetime.getMonth();
  let date = datetime.getDate();
  let hour = datetime.getHours();
  let minute = datetime.getMinutes();
  let second = datetime.getSeconds();

  let result1 = year +
    '-' +
    ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
    '-' +
    ((date + 1) <= 10 ? '0' + date : date) +
    ' ' +
    ((hour + 1) <= 10 ? '0' + hour : hour) +
    ':' +
    ((minute + 1) <= 10 ? '0' + minute : minute) +
    ':' +
    ((second + 1) <= 10 ? '0' + second : second);


  return result1;
}


export const expressData = [
  {
    value: '顺丰速运',
    label: 'SF'
  },
  {
    value: '圆通快递',
    label: 'YTO'
  },
  {
    value: '圆通承诺达',
    label: 'CP468398'
  },
  {
    value: '韵达快递',
    label: 'YUNDA'
  },
  {
    value: '韵达快运',
    label: 'YDKY'
  },
  {
    value: '韵达同城',
    label: 'LE10032270'
  },
  {
    value: '中通快递',
    label: 'ZTO'
  },
  {
    value: '中通快运',
    label: 'ZTOKY'
  },
  {
    value: '申通快递',
    label: 'STO'
  },
  {
    value: '申通快运',
    label: 'STOKY'
  },
  {
    value: '百世快递',
    label: 'HTKY'
  },
  {
    value: '百世快运',
    label: 'BESTQJT'
  },
  {
    value: '百世云配',
    label: 'CP443514'
  },
  {
    value: '极兔快递',
    label: 'JT'
  },
  {
    value: '丰网速运',
    label: 'FW'
  },
  {
    value: '中国邮政',
    label: 'EMS'
  },
  {
    value: '邮政国际包裹',
    label: 'CNPOSTGJ'
  },
  {
    value: 'EMS国际',
    label: 'EMSGJ'
  },
  {
    value: '京东快递',
    label: 'JD'
  },
  {
    value: '德邦快递',
    label: 'DBKD'
  },
  {
    value: '德邦物流',
    label: 'DBL'
  },
  {
    value: '德邦快运',
    label: 'DBKY'
  },
  {
    value: '天天快递',
    label: 'TTKDEX'
  },
  {
    value: '宅急送',
    label: 'ZJS'
  },
  {
    value: '联邦快递',
    label: 'FEDEX'
  },
  {
    value: '苏宁快递',
    label: 'SNWL'
  },
  {
    value: '丹鸟',
    label: 'ZMKM'
  },
  {
    value: 'DHL中国',
    label: 'DHLCN'
  }
]



/* 中国标准时间/毫秒值 转 正常时间 不带时分秒 */
export const TIMEFORMAT = (msec) => {
  let datetime = new Date(msec);
  // console.log(' 自定义时间转换 ', datetime)
  let year = datetime.getFullYear();
  let month = datetime.getMonth();
  let date = datetime.getDate();

  let result2 = year +
    '-' +
    ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
    '-' +
    ((date + 1) < 10 ? '0' + date : date);

  return result2;
}


// 校验两位小数
export const getTofixed = (numBer) => {
  let num = Number(numBer.toString().match(/^\d+(?:\.\d{0,2})?/));
  return num
}


// 销毁标签所存储的内容
export const closeParam = (val) => {
  let arr = localStorage.getItem('params') ? JSON.parse(localStorage.getItem('params')) : []
  console.log('存储---', arr)

  if (arr.length) {
    let isItem = arr.find(item => {
      return item.url == val
    })

    if (isItem) {
      let index = arr.findIndex(item => {
        return item.url == val
      })
      arr.splice(index, 1)
      console.log('index----', index, arr)

    }
    localStorage.setItem('params', arr ? JSON.stringify(arr) : [])

    console.log('是否有存储内容 并 销毁标签-----', isItem, arr)
  }


}

// 返回
export const goBack = (path, NS, navigate) => {
  let arr = []
  let list = []

  JSON.parse(sessionStorage.getItem('navigateList')).map((item, index) => {
    console.log('数据-----', item.path, window.location.pathname.slice(1, window.location.pathname.length))
    if (item.path == window.location.pathname.slice(1, window.location.pathname.length)) {
      console.log('相同数据-----', item)
      localStorage.getItem('path')?.split(',')?.map(item => {
        NS.delList(`/${item.path}${window.location.search}`)
      })
    } else {
      list.push(item)
    }
  })
  localStorage.getItem('path')?.split(',')?.map((item, index) => {
    if (item.split('?')[0] == window.location.pathname) {

    } else {
      arr.push(item)
    }
  })
  NS.navigateList = list
  sessionStorage.setItem('navigateList', JSON.stringify(list))
  console.log('最终的数据-----', arr, list)
  localStorage.setItem('path', arr.toString())
  localStorage.setItem('flagPath', true)

  navigate(path)
  localStorage.removeItem('flagPath')
}



// 没有数据的情况转化为0.00
// 有数据处理为两位小数
// 并且由分转换为元
export const NB = (v) => {
  return v ? (Number(v) * 0.01).toFixed(2) : '0.00'
}

// 没有数据的情况转化为0.00
// 有数据处理为两位小数
// 元
export const NY = (v) => {
  return v ? Number(v).toFixed(2) : '0.00'
}

export const ND = (val) => {
  return (val ?? '') !== '' ? val : '--';
}


// 详情展示 日期转换（数组）
export const dateArray = (val1, val2) => {
  return [moment(val1), moment(val2)]
}
// 详情展示 format日期转换（字符串）
export const formatString = (val1) => {
  return `${moment(val1).format('YYYY-MM-DD HH:mm:ss')}`

}

// 详情展示 format日期转换（数组）
export const formatArray = (val1, val2) => {
  let a = [`${formatString(val1)}` - `${formatString(val2)}`]
  return a
}



// 详情展示 日期转换（字符串-无默认）
export const dateString = (val1) => {
  return val1 ? moment(val1) : null
}
// 详情展示 日期转换（字符串-有默认）
export const dateStringD = (val1) => {
  return val1 ? moment(val1) : moment(moment().format(), 'YYYY-MM-DD')
}